import type { TempoClass } from '../types';

type TempoBadgeProps = {
  tempo: TempoClass | null;
  size?: 'sm' | 'md';
};

const TEMPO_CONFIG: Record<TempoClass, { label: string; emoji: string; color: string }> = {
  fast_start: { label: 'Fast Start', emoji: '⚡', color: 'tempo-fast' },
  slow_start: { label: 'Slow Start', emoji: '🐢', color: 'tempo-slow' },
  strong_finish: { label: 'Strong Finish', emoji: '🔥', color: 'tempo-finish' },
  balanced: { label: 'Balanced', emoji: '⚖️', color: 'tempo-balanced' },
};

export function TempoBadge({ tempo, size = 'sm' }: TempoBadgeProps) {
  if (!tempo) return null;

  const config = TEMPO_CONFIG[tempo];
  const sizeClass = size === 'md' ? 'tempo-badge--md' : '';

  return (
    <span className={`tempo-badge ${config.color} ${sizeClass}`} title={getTempoDescription(tempo)}>
      <span className="tempo-badge__emoji">{config.emoji}</span>
      <span className="tempo-badge__label">{config.label}</span>
    </span>
  );
}

function getTempoDescription(tempo: TempoClass): string {
  switch (tempo) {
    case 'fast_start':
      return 'Scores >55% of goals in first half';
    case 'slow_start':
      return 'Scores <40% of goals in first half';
    case 'strong_finish':
      return 'Scores >25% of goals in last 15 minutes';
    case 'balanced':
      return 'Goals evenly distributed across match';
  }
}

export default TempoBadge;
